// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cebd4a59","455":"d9971c04","588":"b99850d0","643":"ae6080f0","644":"86de32f1","781":"407349d0","865":"a27a3102","878":"6137c8a4"}[chunkId] + ".chunk.js";
};